export default __webpack_public_path__ + "static/media/info.3cb05535.svg";